import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  BooleanTranslateDirective,
  ClickOutsideDirective,
  ConfirmDialogDirective,
  DragAndDropDirective,
} from '@shared/module/serenity-directive/directive';
import {TranslateModule} from '@ngx-translate/core';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {HasPermissionDirective} from './directive/has-permission.directive';


@NgModule({
  declarations: [
    BooleanTranslateDirective,
    ClickOutsideDirective,
    ConfirmDialogDirective,
    DragAndDropDirective,
    HasPermissionDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    DragDropModule
  ],
  exports: [
    BooleanTranslateDirective,
    ClickOutsideDirective,
    ConfirmDialogDirective,
    DragAndDropDirective,
    HasPermissionDirective,
  ]
})
export class SerenityDirectiveModule {
}
